"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addWelfare = addWelfare;
exports.deleteConfigItem = deleteConfigItem;
exports.deleteWelfare = deleteWelfare;
exports.enableConfigItem = enableConfigItem;
exports.generateQrCode = generateQrCode;
exports.getConfigItemDetail = getConfigItemDetail;
exports.getDecorateConfigItem = getDecorateConfigItem;
exports.getWelfareDetail = getWelfareDetail;
exports.getWelfarePage = getWelfarePage;
exports.saveConfigItem = saveConfigItem;
exports.toggleWelfareStatus = toggleWelfareStatus;
exports.updateWelfare = updateWelfare;
exports.updateWelfareEnable = updateWelfareEnable;
exports.welfarePreview = welfarePreview;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
/**
 * 分页查询装修-福利社
 * @param {Object} params - 查询参数 {page, limit}
 * @returns {Promise}
 */
function getWelfarePage(params) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateWelfare/page',
    method: 'get',
    params: params
  });
}

/**
 * 新增装修-福利社
 * @param {Object} data - 福利社数据
 * @returns {Promise}
 */
function addWelfare(data) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateWelfare',
    method: 'post',
    data: data
  });
}

/**
 * 修改装修-福利社
 * @param {Object} data - 福利社数据
 * @returns {Promise}
 */
function updateWelfare(data) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateWelfare',
    method: 'put',
    data: data
  });
}

/**
 * 获取装修-福利社详情
 * @param {Number} id - 福利社ID
 * @returns {Promise}
 */
function getWelfareDetail(id) {
  return (0, _requestAuth.default)({
    url: "/xyDecorateWelfare/".concat(id),
    method: 'get'
  });
}

/**
 * 删除装修-福利社
 * @param {Number} id - 福利社ID
 * @returns {Promise}
 */
function deleteWelfare(id) {
  return (0, _requestAuth.default)({
    url: "/xyDecorateWelfare/".concat(id),
    method: 'delete'
  });
}

/**
 * 启用/禁用装修-福利社
 * @param {Number} id - 福利社ID
 * @returns {Promise}
 */
function toggleWelfareStatus(id) {
  return (0, _requestAuth.default)({
    url: "/xyDecorateWelfare/".concat(id, "/status"),
    method: 'put'
  });
}

/**
 * 修改装修-福利社状态
 * @param {Object} data - 福利社数据 {id, enable}
 * @returns {Promise}
 */
function updateWelfareEnable(data) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateWelfare/enable',
    method: 'put',
    data: data
  });
}

/**
 * 查询配置项列表信息
 * @param {String} pageCode - 页面编码
 * @param {String} optionCode - 模块编码
 * @param {Integer} page - 页码
 * @param {Integer} size - 每页大小
 * @returns {Promise}
 */
function getDecorateConfigItem(pageCode, optionCode, page, size, searchName, publishPositionFilter) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateConfig/decorateConfigItem',
    method: 'get',
    params: {
      pageCode: pageCode,
      optionCode: optionCode,
      page: page,
      size: size,
      title: searchName,
      type: publishPositionFilter
    }
  });
}

/**
 * 保存/修改装修配置项
 * @param {Object} data - 配置项数据
 * @returns {Promise}
 */
function saveConfigItem(data) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateConfig/saveConfigItem',
    method: 'post',
    data: data
  });
}

/**
 * 查询配置项详情信息
 * @param {Long} id - 配置项ID
 * @returns {Promise}
 */
function getConfigItemDetail(id) {
  return (0, _requestAuth.default)({
    url: "/xyDecorateConfig/configItemDetail/".concat(id),
    method: 'get'
  });
}

/**
 * 删除配置项信息
 * @param {Long} id - 配置项ID
 * @returns {Promise}
 */
function deleteConfigItem(id) {
  return (0, _requestAuth.default)({
    url: "/xyDecorateConfig/configItemDel/".concat(id),
    method: 'get'
  });
}

/**
 * 启用/禁用配置项
 * @param {Long} id - 配置项ID
 * @returns {Promise}
 */
function enableConfigItem(id) {
  return (0, _requestAuth.default)({
    url: "/xyDecorateConfig/configItemEnable/".concat(id),
    method: 'get'
  });
}

/**
 * 生成二维码
 * @param {Long} configId - 配置项ID
 * @returns {Promise}
 */
function generateQrCode(configId, xcxType) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateConfig/generateQrCode',
    method: 'get',
    params: {
      configId: configId,
      xcxType: xcxType
    }
  });
}

/**
 * 福利社预览
 * @param {Object} data - 预览数据 {ids, pageCode, optionCode, xcxType, pageURl}
 * @returns {Promise}
 */
function welfarePreview(data) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateWelfare/welfarePreView',
    method: 'post',
    data: data
  });
}